// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".law_firm_follow-module__container--3ThWS{margin:0;margin-top:16px}\n", ""]);
// Exports
exports.locals = {
	"container": "law_firm_follow-module__container--3ThWS"
};
module.exports = exports;
